import { createGlobalStyle } from 'styled-components';

interface DSTheme {
  font: {
    family: {
      body: string;
    };
    weight: {
      regular: string;
    };
    size: {
      base: string;
    };
  };
}

export const GlobalStyle = createGlobalStyle<{ theme: DSTheme }>`
body {
  overflow-x:hidden;
}
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.font.family.body};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.base};
    
  }

  a {
    text-decoration: none
  }
`;

export default GlobalStyle;
